import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import {
  ManageCegTableRowPerformance,
  ManageTableDataMode,
  ManageTableTotalValues,
  PresentationTimeframe
} from '@manage-ceg/types/manage-ceg-page.types';
import { slideFromRightColumnAnimations } from '@manage-ceg/constants/manage-ceg-page.constants';
import { ManageTableCegRowBaseComponent } from '@manage-ceg/components/manage-table-ceg/components/manage-table-ceg-row-base';
import { FilterManagementService } from 'app/header-navigation/components/filters/filter-services/filter-management.service';
import { FilterSet } from 'app/header-navigation/components/filters/filters.interface';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: '[manage-table-ceg-foot-row]',
  templateUrl: './manage-table-ceg-foot-row.component.html',
  styleUrls: ['./manage-table-ceg-foot-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    slideFromRightColumnAnimations,
  ],
})
export class ManageTableCegFootRowComponent extends ManageTableCegRowBaseComponent implements OnInit, OnDestroy{
  @Input() grandTotalBudget: Record<PresentationTimeframe, ManageTableTotalValues>;
  @Input() grandTotalPerformance: ManageCegTableRowPerformance;
  @Input() grandTotalForActiveTimeframes: ManageTableTotalValues;
  protected ManageTableDataMode = ManageTableDataMode;
  private readonly filterManagementService = inject(FilterManagementService);
  private readonly destroy$ = new Subject<void>();
  timeframeSelectedFilters: any[] = [];
  

  ngOnInit(): void {
    this.filterManagementService.currentFilterSet$
      .pipe(takeUntil(this.destroy$))
      .subscribe((filterSet: FilterSet) => {
        this.timeframeSelectedFilters = filterSet?.timeframes || [];
      });
  }
 
  // Cleans up all subscriptions when the component is destroyed
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  
}
